import React from 'react';

import AuditLogModal from 'app/audit-logs/AuditLogModal';
import usePipelinesAuditLogModal from './usePipelinesAuditLogModal';

export default function PipelinesAuditLogModal() {
  const { open, onClose, recordRef } = usePipelinesAuditLogModal();

  return <AuditLogModal open={open} onClose={onClose} recordRef={recordRef} />;
}
